var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectBuildingGarun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1334,
    viewBox: "0 0 2000 1334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "B1-1",
    d: "M84.2559 1277.35L84.2559 1224.5L488.5 1222.57L501.749 1222.57H685L691 1222.57H907.175H907.68H915.907H955.543V1217.17L963.866 1206.87H1036.4V1222.57H1096.84L1105.4 1231.07V1276.71L84.2559 1277.35Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "B11",
    d: "M915 1222.5V1186H907.5V1185L691 1185.5L688 1182H505.5L499.5 1186.5H84.2471V1225L915 1222.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "B115",
    d: "M55.4733 457.111V441.463L86.5865 441.433V416.742L184.508 416.35H186.072H503.333L505.815 414.56L691.556 414.824L693.139 417.364H908.183V431.387L929.701 431.335V441.862L950.688 441.862V494.147L929.748 494.147V484.536H908.156V472.47H692.526L691.363 469.73L505.829 469.175L503.275 471.148H53.3247V457.111H55.4733Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "B114",
    d: "M54.3286 511.357V495.786H86.2615V471.352H184.461L185.213 472.837L503.226 471.075L505.791 469.188L691.379 469.699L692.573 472.382L908.184 472.861V484.625L929.701 484.573V494.243H950.699V546.528H929.748V538.571H908.156V527.488H692.526L691.379 525.156L506.169 524.214L503.275 525.488L52.5005 525.886V511.357H54.3286Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "B113",
    d: "M53.3128 566.498V548.328H85.3955V525.862H184.461L185.212 527.343L503.226 525.581L506.225 524.168L691.273 524.871L692.573 526.96L908.183 527.439V538.63L929.701 538.578V546.785H950.696V599.07H929.748V592.37H908.156V581.486H692.526L690.75 579.746L505.928 579.084L502.869 580.884L50.9473 580.18V566.498H53.3128Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "B112",
    d: "M52.4544 621.533V604.579H84.4275V580.458H184.027H185.169L502.857 580.922L505.94 579.031L690.657 579.557L692.476 581.845L908.131 581.516V592.379L929.648 592.328V599.796L950.699 599.843V653.571L929.695 653.524V645.436H908.103V635.663H692.473L690.697 633.495L505.965 633.285L502.784 635.428H276.699H50.5518V621.533H52.4544Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "B111",
    d: "M51.5046 675.491V659.679H83.21V635.45H184.028H185.14L502.859 635.183L505.941 633.292L690.658 633.819L692.478 636.106L908.132 635.777V645.491L929.65 645.439V654.057H950.693V706.587H929.697V699.394H907.488V690.451H692.475L690.626 687.988L505.966 687.546L502.786 689.689H276.701L49.4619 689.322V675.491H51.5046Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "B110",
    d: "M50.5281 730.466V713.634H82.5228V689.405H184.02H185.132L502.85 689.139L505.933 687.247L690.65 687.774L692.469 690.829L907.442 690.501V699.447L929.693 699.394V706.571H950.706V759.522H929.689V753.349H907.48V745.521H692.466L690.618 741.943L505.958 741.501L502.777 743.644L276.693 744.012L48.5127 743.644V730.466H50.5281Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "B19",
    d: "M49.6446 785.464L49.6447 769.455H81.6004V743.732H132.747H183.773H185.293H502.851L505.934 741.381L690.651 741.908L692.511 745.59H907.442V753.581L929.693 753.528V759.499H950.685V811.355H929.689V806.194H907.481V800.489H692.467L690.618 797.779L505.958 797.337L502.223 799.433H276.303H47.5488L47.5489 785.464H49.6446Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "B18",
    d: "M49.6446 841.507L49.6446 824.518H80.5116V799.469L132.903 799.31H158.244H183.543L185.576 799.347H502.283L505.934 797.141L690.651 797.668L692.511 800.43H907.442V806.298L929.693 806.246V811.338L950.704 811.512L950.704 864.655L929.689 864.481L929.689 859.483H907.481V854.497H692.467L691.018 852.101H506.301L501.354 854.073L276.303 854.673H47.5488L47.5489 841.507H49.6446Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "B17",
    d: "M48.8516 896.457L48.8516 879.574H80.5122V854.673L132.766 854.487H145.499H158.198H183.094H191.427L501.113 854.179L506.219 852.12L690.957 852.12L692.512 854.437H907.442V859.767L929.694 859.714V864.806H950.68L950.68 917.949H929.689L929.689 913.536H907.481V910.458H692.467L689.951 907.427H506.219L500.861 909.535H276.304H46.4707L46.4707 896.457H48.058H48.8516Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "B16",
    d: "M47.5087 950.389L47.5087 933.506H80.5114V909.524L132.441 909.396H145.181H158.079H183.049H191.493H500.867L506.147 907.461H689.909L692.511 910.529H907.442V913.699L929.693 913.646V917.943H950.696V972.453H929.688L929.689 968.441H907.48L907.48 965.419H692.466L689.95 961.359H505.704L500.526 964.539L276.303 965.444L44.9233 964.574L44.9234 951.496L47.5094 951.496L47.5087 950.389Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "B15",
    d: "M47.5092 1004.26L47.5092 988.967H78.2998V964.979L132.039 965.168H138.458H144.973H158.08H183.05H191.493H500.868L505.604 961.61L690.076 961.321L692.313 965.045L799.92 965.342L853.681 965.193H880.605H907.442V968.582L929.694 968.531L929.694 972.455H950.694L950.694 1025.85H929.689V1022.82H907.481L907.481 1020.42L692.849 1021.08L689.381 1015.98H505.431L500.526 1020.29H275.574H44.3867V1005.66L47.5099 1005.66L47.5092 1004.26Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "B14",
    d: "M45.7906 1059L45.7906 1044.74H77.3951V1018.79L131.33 1019.17L138.463 1019.07H144.978H158.024L183.054 1019.17H191.498L500.597 1018.66L505.684 1015.37L689.467 1016.35L692.913 1021.05L907.447 1020.34V1023.01L929.698 1022.96V1025.94H950.703L950.703 1079.48H929.694L929.694 1077.01H907.486L907.486 1074.51H692.472L688.939 1071.44H505.709L500.531 1074.62L276.309 1075.69L43.4429 1074.94V1061.19L45.7906 1061.19V1059Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "B13",
    d: "M45.7178 1112.84L45.7178 1098.58H76.4149V1075.14L131.263 1075.35H138.751H145.576H158.429H183.641H192.887L500.578 1075.09L505.836 1071.44L689.439 1072.5L692.739 1074.48H907.435V1077.18L929.688 1077.13V1079.48L950.7 1079.59L950.7 1133.12L929.402 1133.01V1130.59H907.473V1128.97L691.294 1129.35L688.354 1127.37H505.505L500.49 1130.54L276.252 1131.61L42.5044 1131.11V1117.42H45.7178V1112.84Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "B12",
    d: "M44.6717 1167.57L44.6717 1152.87H75.4043V1131.19H102.676L130.09 1131.37H137.533H144.48H157.5H182.491H191.444L500.538 1130.49L505.387 1127.42L688.346 1127.42L691.302 1129.33L907.387 1128.95V1130.81L929.665 1130.75V1133.12H950.708L950.708 1185.84H929.38V1185.88H907.425V1185.04L690.996 1185.43L688.053 1182.56H504.992L499.971 1185.82L275.473 1186.93L41.4546 1186.41V1172.3H44.6717V1167.57Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "B116",
    d: "M55.1797 294.399V304.521L79.3244 328.139V364.535V387.5H53.5V415.5L504 417L506.5 415H691.5L693.5 417.5H908.262V431.5H930V442H951.001V389.021V325.584H941.887V317.691H927.98V295.891H920.412V288.122H682.082V296.077H673.802V297.183H528.265L526.753 293.475H520.086V286.425H65.6078V294.399H55.1797Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "A1-1",
    d: "M1911 1279L1911 1229.34L1520 1227.21H1507.99L1320.65 1227L1106 1225.5V1276.5L1911 1279Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "A11",
    d: "M1911 1229L1911 1186H1504.5L1500 1183H1320.5L1319.5 1186.5H1096.5V1222.5L1106 1232.5V1225.5L1911 1229Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "A12",
    d: "M1950.59 1168L1950.59 1153.62H1920.49V1132.4H1893.77L1866.92 1132.57H1859.63H1852.83H1840.07H1815.59H1806.82L1504.05 1131.71L1499.3 1128.71L1320.09 1128.71L1317.19 1130.58L1105.53 1130.2V1132.02L1083.7 1131.97V1134.29H1063.09L1063.09 1185.87H1083.98V1185.91H1105.49V1185.09L1319.5 1186L1320.37 1182.66H1499.69L1504.61 1185.86L1724.51 1186.94L1953.74 1186.43V1172.62H1950.59V1168Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "A13",
    d: "M1949.57 1114.44L1949.57 1100.49H1919.5V1077.55L1865.77 1077.76H1858.44H1851.75H1839.16H1814.47H1805.41L1504.01 1077.5L1498.86 1073.93L1319.02 1074.97L1315.78 1076.91H1105.48V1079.55L1083.68 1079.49V1081.8L1063.1 1081.9L1063.1 1134.28L1083.96 1134.18V1131.81H1105.44V1130.23L1317.2 1130.6L1320.08 1128.66H1499.19L1504.1 1131.76L1723.75 1132.81L1952.71 1132.32V1118.93H1949.57V1114.44Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "A14",
    d: "M1949.5 1061.76L1949.5 1047.81H1918.54V1022.41L1865.71 1022.78L1858.72 1022.69H1852.34H1839.56L1815.04 1022.78H1806.77L1503.99 1022.29L1499.01 1019.06L1318.99 1020.03L1315.61 1024.63L1105.47 1023.93V1026.55L1083.67 1026.49V1029.41H1063.1L1063.1 1081.8H1083.68L1083.68 1079.39H1105.43L1105.43 1076.94H1316.04L1319.51 1073.93H1498.99L1504.06 1077.04L1723.69 1078.09L1951.79 1077.35V1063.9L1949.5 1063.9V1061.76Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "A15",
    d: "M1947.81 1008.2L1947.81 993.23H1917.65V969.757L1865.01 969.942H1858.72H1852.34H1839.5H1815.04H1806.77H1503.73L1499.09 966.461L1318.39 966.178L1316.2 969.822L1210.79 970.112L1158.13 969.967H1131.76H1105.47V973.283L1083.68 973.233L1083.68 977.073H1063.11L1063.11 1029.32H1083.68V1026.36H1105.44L1105.44 1024.01L1315.68 1024.66L1319.07 1019.67H1499.26L1504.06 1023.88H1724.41H1950.87V1009.57L1947.81 1009.57L1947.81 1008.2Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "A16",
    d: "M1947.81 955.481L1947.81 938.96H1915.48V915.494L1864.62 915.368H1852.14H1839.5H1815.05H1806.77H1503.73L1498.56 913.475H1318.56L1316.01 916.477H1105.47V919.579L1083.68 919.527V923.732H1063.1V977.071H1083.68L1083.68 973.145H1105.44L1105.44 970.188H1316.05L1318.52 966.215H1498.99L1504.06 969.327L1723.7 970.212L1950.34 969.361L1950.34 956.564L1947.81 956.564L1947.81 955.481Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "A17",
    d: "M1946.5 902.708L1946.5 886.187H1915.48V861.821L1864.3 861.639H1851.83H1839.39H1815H1806.84L1503.49 861.337L1498.49 859.322L1317.53 859.322L1316.01 861.59H1105.47V866.805L1083.68 866.753V871.736H1063.12L1063.12 923.738H1083.68L1083.68 919.419H1105.43V916.408H1316.05L1318.51 913.441H1498.49L1503.74 915.505H1723.7H1948.83L1948.83 902.708H1947.27H1946.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "A18",
    d: "M1945.72 848.937L1945.72 832.314H1915.48V807.802L1864.17 807.647H1839.34H1814.56L1812.57 807.683H1502.34L1498.77 805.524L1317.83 806.04L1316.01 808.742H1105.47V814.485L1083.68 814.433V819.416L1063.1 819.586L1063.1 871.588L1083.68 871.418L1083.68 866.527H1105.44V861.649H1316.05L1317.47 859.304H1498.41L1503.25 861.233L1723.7 861.821H1947.77L1947.77 848.937H1945.72Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "A19",
    d: "M1945.72 794.098L1945.72 778.433H1914.42V753.262H1864.32H1814.34H1812.85H1501.79L1498.77 750.962L1317.83 751.477L1316.01 755.081H1105.47V762.9L1083.68 762.848V768.69H1063.11V819.433H1083.68V814.383H1105.44V808.8H1316.05L1317.86 806.148L1498.74 805.716L1502.4 807.767H1723.7H1947.77L1947.77 794.098H1945.72Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "A110",
    d: "M1944.85 740.281V723.81H1913.51V700.102H1814.09H1813L1501.79 699.841L1498.77 697.99L1317.83 698.506L1316.05 701.495L1105.47 701.175V709.928L1083.68 709.877V716.9H1063.09V768.713H1083.68V762.673H1105.44V755.013H1316.05L1317.86 751.512L1498.74 751.08L1501.86 753.176L1723.32 753.536L1946.83 753.176V740.281H1944.85Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "A111",
    d: "M1943.9 686.487V671.014H1912.84V647.306H1814.09H1813L1501.78 647.045L1498.76 645.194L1317.82 645.709L1316.04 647.947L1104.8 647.626V657.131L1083.72 657.08V665.513H1063.11V716.915H1083.67V709.876H1105.43V701.126H1316.04L1317.85 698.716L1498.73 698.283L1501.85 700.38H1723.31L1945.9 700.021V686.487H1943.9Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "A112",
    d: "M1942.97 633.687V617.098H1911.65V593.495H1814.09H1812.97L1501.78 593.949L1498.76 592.098L1317.82 592.614L1316.04 594.852L1104.8 594.53V605.16L1083.72 605.11V612.417L1063.1 612.463V665.038L1083.68 664.992V657.078H1104.83V647.515H1316.04L1317.78 645.393L1498.74 645.187L1501.85 647.284H1723.31H1944.83V633.687H1942.97Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "A113",
    d: "M1942.13 579.835V562.055H1910.7V540.072H1813.66L1812.93 541.521L1501.42 539.797L1498.48 538.414L1317.22 539.102L1315.95 541.146L1104.75 541.614V552.565L1083.67 552.515V560.545H1063.1V611.707H1083.62V605.151H1104.77V594.501H1315.99L1317.73 592.798L1498.77 592.151L1501.77 593.912L1944.44 593.223V579.835H1942.13Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "A114",
    d: "M1941.13 525.878V510.642H1909.85V486.732H1813.66L1812.93 488.186L1501.42 486.461L1498.91 484.615L1317.12 485.115L1315.95 487.74L1104.75 488.209V499.721L1083.67 499.67V509.132H1063.1V560.294H1083.62V552.507H1104.77V541.663H1315.99L1317.12 539.381L1498.54 538.459L1501.37 539.705L1942.92 540.095V525.878H1941.13Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "A115",
    d: "M1940.01 472.797V457.485L1909.53 457.456V433.295L1813.62 432.912H1812.08H1501.31L1498.88 431.16L1316.94 431.418L1315.39 433.903H1104.75V447.625L1083.67 447.575V457.876L1063.11 457.876V509.038L1083.62 509.038V499.633H1104.77V487.826H1315.99L1317.13 485.145L1498.87 484.602L1501.37 486.532H1942.12V472.797H1940.01Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "A116",
    d: "M1938.5 404V420H1940.49V432.272L1813.58 433.932L1812.29 432.272H1501.03L1498.45 431.103H1316.94L1315.52 433.438H1104.9V448.336H1083.05V457.892H1063V343.5H1072.5V337H1083.5V331H1084.5V315.5H1094V308.5H1324V314.5H1333L1335 317L1476 316V319H1479V313H1486.5V306H1928V313.5L1939.5 313V324L1916 344.5L1917.5 404H1938.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBuildingGarun);
export default __webpack_public_path__ + "static/media/select_building_garun.4e581dde.svg";
export { ForwardRef as ReactComponent };